
        Component.define('share', (el, params) => {
            /**
 * Cada componente recebe as variáveis explicadas abaixo
 *
 * @param {HTMLElement} el - Elemento DOM que seleciona o componente em si
 * @param {Object} params  - Parâmetros para serem utilizados
 */

const $el  = $(el);

$el.on('icon-share:removeActive', function(evt, id){
    //console.log($el.find('.icon-save[data-id="'+id+'"]'));
    //$el.find('.icon-save[data-id="'+id+'"]').removeClass('active');
});

$el.find('.icon-share').on('click', function(e){
    let $this = $(this);
    e.preventDefault();
    const url = $(this).attr('data-href');
    Share.copyToClickBoard(url, $this);
});

        });